import api from 'api';

export const loadFavorites = api('GET /api/profile/favorite-filters/:screen');

export const saveFavorites = api('PUT /api/profile/favorite-filters/:screen');
